export enum project {
  lms = "lms-v2",
  hr = "hr-v2",
  ars = "ars",
  task = "task",
  ielts = "ielts-testing-platform",
}
